enum OfferType {
  BUNDLE = 'Bundle',
  FIXED = 'Fixed',
  FLEX = 'Flex',
  SEASON = 'Season',
  SINGLE = 'Single',
}
export { OfferType };
